
import { Crown } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function PremiumBadge() {
  return (
    <div className="text-center mb-8">
      <Badge variant="default" className="px-4 py-2 text-base font-semibold bg-app-accent text-app-accent-foreground hover:bg-app-accent/90 transition-colors duration-300">
        <Crown className="w-5 h-5 mr-2" />
        Premium Member
      </Badge>
    </div>
  );
}
